import {validateLineup} from '../../utils/matchLineup';
import {TEAM_STATS_AGENT_OPTIONS} from '../../core-pages/team-stats/teamStatsFormOptions';
export const MAX_SAVED_COMPS = 4;
export const emptyPresetLineup = () => Array.from({length:5}, () => ({uid:'', username:'', agent:''}));
export const presetMapKey = name => encodeURIComponent(String(name || '').trim().toLowerCase());
export function canEditCompositionPresets(team, uid) {
  return !!uid && (team?.members || []).some(member => (typeof member === 'string' ? member : member.uid) === uid)
    && !String(team?.teamRoles?.[uid] || '').trim().toLowerCase().startsWith('trial');
}
export function presetForEvent(preset, members) {
  const missing = [];
  const lineup = emptyPresetLineup().map((_, index) => {
    const row = preset.lineup[index] || {}, person = members.find(member => member.uid === row.uid);
    if (row.uid && !person) missing.push(row.username || 'Former member');
    return {uid:person?.uid || '', username:person?.username || '', agent:row.agent || ''};
  });
  return {lineup, missing};
}
export function updatePresetMap(current, preset, designation, members) {
  if (!preset.name.trim() || preset.name.trim().length > 80) throw new Error('Enter a composition name of up to 80 characters.');
  if (!['main','secondary','custom'].includes(designation)) throw new Error('Choose a valid Comp Name.');
  const assignedId=current[designation + 'Id'];
  if (designation !== 'custom' && assignedId && assignedId !== preset.id) throw new Error('This map already has a ' + (designation === 'main' ? 'Main Comp' : 'Secondary Comp') + '. Choose another Comp Name.');
  if ((current.presets || []).some(item=>item.id !== preset.id && item.name.trim().toLowerCase() === preset.name.trim().toLowerCase())) throw new Error('A composition with this name already exists on this map. Choose a unique name.');
  if (preset.lineup.length !== 5) throw new Error('A composition must contain five slots.');
  validateLineup(preset.lineup);
  const normalized = {...preset, name:preset.name.trim(), lineup:preset.lineup.map(row => {
    const person = members.find(member => member.uid === row.uid);
    if (row.uid && !person) throw new Error('Choose current team members for this composition.');
    if (row.agent && !TEAM_STATS_AGENT_OPTIONS.includes(row.agent)) throw new Error('Choose a valid agent.');
    return {uid:person?.uid || '', username:person?.username || '', agent:row.agent || ''};
  })};
  const presets = [...(current.presets || []).filter(item => item.id !== preset.id), normalized];
  if (presets.length > MAX_SAVED_COMPS) throw new Error('A map can have up to four saved compositions.');
  const next = {...current, presets};
  if (next.mainId === preset.id) next.mainId = '';
  if (next.secondaryId === preset.id) next.secondaryId = '';
  if (designation === 'main') next.mainId = preset.id;
  if (designation === 'secondary') next.secondaryId = preset.id;
  return next;
}

export function readPresetMap(document = {}) {
  const data = document.content ? JSON.parse(document.content) : {presets:[],mainId:'',secondaryId:''};
  if (!Array.isArray(data.presets) || data.presets.length > 10 || typeof data.mainId !== 'string' || typeof data.secondaryId !== 'string') throw new Error('Invalid saved composition data.');
  const ids = data.presets.map(preset => preset.id);
  if (new Set(ids).size !== ids.length || (data.mainId && !ids.includes(data.mainId)) || (data.secondaryId && (!ids.includes(data.secondaryId) || data.mainId === data.secondaryId))) throw new Error('Invalid saved composition designations.');
  for (const preset of data.presets) {
    if (typeof preset.id !== 'string' || !preset.id || preset.id.length > 128 || typeof preset.name !== 'string' || !preset.name.trim() || preset.name.length > 80 || !Array.isArray(preset.lineup) || preset.lineup.length !== 5) throw new Error('Invalid saved composition.');
    validateLineup(preset.lineup);
    for (const row of preset.lineup) if (!row || typeof row.uid !== 'string' || row.uid.length > 128 || typeof row.username !== 'string' || row.username.length > 160 || typeof row.agent !== 'string' || (row.agent && !TEAM_STATS_AGENT_OPTIONS.includes(row.agent))) throw new Error('Invalid saved composition assignment.');
  }
  return {...data,revision:document.revision || ''};
}
